import { faLock, faMessageBot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Privacy } from '@playcastdotio/Settings';
import { Label } from '@playcastdotio/Shadcn';
import { createRoot } from 'react-dom/client';
import { Tools } from './Tools';
import { useContext, useEffect, useState } from 'react';
import { PlaycastContext } from '../PlaycastWrapper';
import { useClerk } from '@clerk/clerk-react';

export const ChatBotShare = () => {
  const context = useContext(PlaycastContext);
  const { openUserProfile } = useClerk();

  const [allowPeerConnections, setInternalAllowPeerConnections] = useState(context.stateStores.iceServerState.allowPeerConnections);
  const setAllowPeerConnections = (allowPeerConnections: boolean) => {
    context.targetFunctions.setAllowPeerConnections(allowPeerConnections);
    setInternalAllowPeerConnections(allowPeerConnections);
  };
  useEffect(() => {
    setInternalAllowPeerConnections(context.stateStores.iceServerState.allowPeerConnections);
  }, [context.stateStores.iceServerState.allowPeerConnections]);

  // this function is a duplicate of navbar line 609
  // global clerk function should fix this duplication
  // this should be good for now
  const openUserProfileSettings = () => {
    const hiddenElementsWhenStreaming = {
      profileSectionItem__phoneNumbers: 'blur-md',
      profileSectionItem__emailAddresses: 'blur-md',
      profileSectionItem__connectedAccounts: 'blur-md',
      profileSectionItemList__username: 'blur-md',
      profileSectionItem__profile: 'blur-md',
      profileSectionItem__profileText: 'blur-md',
      profileSectionPrimaryButton: 'invisible',
      menuButton__mfa: 'invisible',
      activeDeviceListItem: 'blur-md',
      headerTitle: 'sensitive-content',
    };

    // setShow(false);
    const electronElements = {
      card: '!shadow-none',
      rootBox: '!shadow-none',
      userPreviewMainIdentifier: 'font-semibold',
      userPreviewSecondaryIdentifier: 'text-gray-500',
      menuItem__connectedAccounts: 'hidden',
      menuButton__connectedAccounts: 'hidden',
    };
    const remoteElements = {
      card: '!shadow-none',
      rootBox: '!shadow-none',
      userPreviewMainIdentifier: 'font-semibold',
      userPreviewSecondaryIdentifier: 'text-gray-500',
    };
    let showElements = context.electronFunctions ? electronElements : remoteElements;
    if (context.stateStores.hostState.status === 'streaming' && context.electronFunctions) {
      showElements = {
        ...showElements,
        ...hiddenElementsWhenStreaming,
      };
    }
    openUserProfile({
      __experimental_startPath: '/tools',
      appearance: {
        elements: showElements,
      },
      customPages: [
        {
          url: 'privacy',
          label: 'Privacy',
          mountIcon: (el: any) => {
            const root = createRoot(el);
            root.render(<FontAwesomeIcon icon={faLock} className='text-md' />);
            el.__root = root;
          },
          unmountIcon: (el: any) => {
            if (el && el.__root) {
              el.__root.unmount();
              delete el.__root;
            }
          },
          mount: (el: any) => {
            const root = createRoot(el);
            root.render(
              <Privacy
                edition={context.stateStores.hostState.edition ?? 'standard'}
                allowPeerConnections={allowPeerConnections}
                setAllowPeerConnections={setAllowPeerConnections}
              />,
            );
            el.__root = root;
          },
          unmount: (el: any) => {
            if (el && el.__root) {
              el.__root.unmount();
              delete el.__root;
            }
          },
        },
        {
          url: 'tools',
          label: 'Tools',
          mountIcon: (el: any) => {
            const root = createRoot(el);
            root.render(<FontAwesomeIcon icon={faMessageBot} className='text-md' />);
            el.__root = root;
          },
          unmountIcon: (el: any) => {
            if (el && el.__root) {
              el.__root.unmount();
              delete el.__root;
            }
          },
          mount: (el: any) => {
            const root = createRoot(el);
            root.render(<Tools context={context} />);
            el.__root = root;
          },
          unmount: (el: any) => {
            if (el && el.__root) {
              el.__root.unmount();
              delete el.__root;
            }
          },
        },
      ],
    });
  };

  return (
    <button className='group flex items-center' onMouseDown={openUserProfileSettings} data-testid='share-chatbot-button'>
      <div className='group-hover:border-midnight-bright flex w-full cursor-pointer gap-2 rounded-md border-2 border-gray-300 p-2 text-left text-sm font-normal group-hover:border-dashed'>
        <FontAwesomeIcon icon={faMessageBot} />
        <Label className='cursor-pointer'>Chatbot Share</Label>
      </div>
    </button>
  );
};
